function newsletterEnviar(){
	var email = $('#newsEmail').val();
	$('.newsletterDiv .codecontent').hide();
	$.post("/async/addnewsletter",{ email : email },function(data){
		$('.newsletterDiv .code'+data.code).show();
	},"json");
}

function contactoEnviar(){
	var nombre = $('#contacto_nombre').val();
	var apellido = $('#contacto_apellido').val();
	var email = $('#contacto_email').val();
	var tel = $('#contacto_tel').val();
	var seguridad = $('#seguridad').val();
	var direccion = $('#contacto_direccion').val();
	var lang_id = $('body').attr("data-lang_id");
	var pregunta = $('#contacto_pregunta').val();
	var page = $('body').attr("data-id");
	$('.contactoDiv .codecontent').hide();
	$.post("/async/addcontacto",{ seguridad:seguridad, nombre : nombre, apellido : apellido, email : email, tel : tel, direccion : direccion, pregunta : pregunta, page : page, lang_id : lang_id },function(data){
		$('.contactoDiv .code'+data.code).show();
	},"json");
}

function contactoEnviarInter(){
	var name_company = $('#name_company').val();
	var company_tax = $('#company_tax').val();
	var industry = $('#industry').val();
	var nature_business = $('#nature_business').val();
	var address = $('#address').val();
	var lang_id = $('body').attr("data-lang_id");
	var email = $('#email').val();
	var name = $('#name').val();
	var position = $('#position').val();
	var telephone_number = $('#telephone_number').val();
	var name_post_offer = $('#name_post_offer').val();
	var department = $('#department').val();
	var detailed_description = $('#detailed_description').val();
	var otherlang = $('#otherlang').val();
	var languages = $('.groupLang input[type="checkbox"]:checked').map(function () {
	  return this.value;
	}).get();
	var number_places = $('#number_places').val();
	var page = $('body').attr("data-id");
	var start_date = $('#start_date').val();
	var finish_date = $('#finish_date').val();
	var place_work = $('#place_work').val();
	var remuneration = $('#remuneration').val();
	var working_day = $('#working_day').val();
	var total_number = $('#total_number').val();
	var applicant_profile = $('#applicant_profile').val();

	$.post("/async/addcontactointer",{ 
		name_company : name_company,
		company_tax : company_tax,
		lang_id : lang_id,
		industry : industry,
		nature_business : nature_business,
		address : address,
		email : email,
		otherlang : otherlang,
		languages : languages,
		remuneration : remuneration,
		name : name,
		position : position,
		telephone_number : telephone_number,
		name_post_offer : name_post_offer,
		department : department,
		detailed_description : detailed_description,
		number_places : number_places,
		start_date : start_date,
		finish_date : finish_date,
		place_work : place_work,
		page : page,
		working_day : working_day,
		total_number : total_number,
		applicant_profile : applicant_profile
	 },function(data){
		$('.contactoDiv .code'+data.code).show();
	},"json");
}

function contactoEmpresaEnviar(){
	var empresa = $('#contactoEm_empresa').val();
	var contacto = $('#contactoEm_contacto').val();
	var cargo = $('#contactoEm_cargo').val();
	var telefono = $('#contactoEm_telefono').val();
	var seguridad = $('#seguridad').val();
	var email = $('#contactoEm_email').val();
	var lang_id = $('body').attr("data-lang_id");
	var web = $('#contactoEm_web').val();
	var observaciones = $('#contactoEm_observaciones').val();
	var page = $('body').attr("data-id");
	$('.contactoempresaDiv .codecontent').hide();
	$.post("/async/addcontactoempresa",{ seguridad:seguridad, empresa : empresa, contacto : contacto, cargo : cargo, telefono : telefono, email : email, web : web, observaciones : observaciones, page : page, lang_id : lang_id },function(data){
		$('.contactoempresaDiv .code'+data.code).show();
	},"json");
} 

function contratacionEnviar(){
	var contratacion_nombre_empresa = $('#contratacion_nombre_empresa').val();
	var contratacion_persona_contacto = $('#contratacion_persona_contacto').val();
	var contratacion_telefono = $('#contratacion_telefono').val();
	var contratacion_fax = $('#contratacion_fax').val();
	var contratacion_direccion = $('#contratacion_direccion').val();
	var contratacion_email = $('#contratacion_email').val();
	var contratacion_expediente = $('#contratacion_expediente').val();
	var contratacion_observaciones = $('#contratacion_observaciones').val();

	var page = $('body').attr("data-id");
	var lang_id = $('body').attr("data-lang_id");
	$('.contactoDiv .codecontent').hide();

	$.post("/async/addcontratacion",{ contratacion_nombre_empresa:contratacion_nombre_empresa,  contratacion_persona_contacto : contratacion_persona_contacto,  contratacion_telefono : contratacion_telefono,  contratacion_fax : contratacion_fax,  contratacion_direccion : contratacion_direccion,  contratacion_email : contratacion_email,  contratacion_expediente : contratacion_expediente,  contratacion_observaciones : contratacion_observaciones,  page : page,  lang_id : lang_id },function(data){
		$('.contactoDiv .code'+data.code).show();
	},"json");
} 

$(document).on("change","#working_day",function(){
	if($(this).val()=="5"){
		$('#total_number').show();
	}else{
		$('#total_number').hide();
		$('#total_number').val("");

	}
})

$(document).ready(function(){
	$('.groupLang input').on('ifChanged', function(event){
		var languages = $('.groupLang input[type="checkbox"]:checked').map(function () {
		  return this.value;
		}).get();
		var other = false;
		for(var cont=0;cont<languages.length;cont++){
			if(languages[cont]=='5'){
				other = true;
			}
		}
	    if(other){
			$('.otherlang').show();
		}else{
			$('.otherlang').hide();

		}
	});
	
});

